import { ActionTypes } from "../constants/actionType";

const initialState = {
  category: "Gateway",
};

export const consoleCategoryReducer = (
  state: any = initialState.category,
  action: any
) => {
  switch (action.type) {
    case ActionTypes.SET_CONSOLE_CATEGORY:
      return action.payload;
    default:
      return state;
  }
};
